import React from "react";
import { IListItem } from "api/types/originacion/commonTypes";
import {
  EEstadoSolicitudConsumo,
  ESituacionOperacion,
} from "api/types/originacion/businessTypes";
import FilterSelector from "components/styled/dropDownSelector/FilterSelector";

interface IEstadoSolicitudDropdown {
  selected: string;
  onSelected(newValue: string): void;
  group: "Analisis" | "Confeccion" | "Liquidacion" | "Consumo" | "ConsumoYen";
  estadoSeleccionado?: string;
}

const EstadoSolicitudDropdown: React.FC<IEstadoSolicitudDropdown> = ({
  selected,
  onSelected,
  group = "Analisis",
  estadoSeleccionado,
}) => {
  const getRangoFechaConsumo = (estadoSeleccionado: string): IListItem[] => {
    const opcionesBase = [
      {
        value: "Alta",
        label: "Fecha de Alta",
      },
    ];

    if (estadoSeleccionado === "Aprobada") {
      return [
        ...opcionesBase,
        {
          value: ERangoFecha.Aprobada,
          label: "Fecha de Aprobación",
        },
      ];
    }

    if (estadoSeleccionado === "Liquidada") {
      return [
        ...opcionesBase,
        {
          value: ERangoFecha.Liquidada,
          label: "Fecha de Liquidación",
        },
      ];
    }

    return opcionesBase;
  };

  const items =
    group === "ConsumoYen" && estadoSeleccionado
      ? getRangoFechaConsumo(estadoSeleccionado)
      : estadosSolicitud[group];

  return (
    <FilterSelector value={selected} items={items} onChange={onSelected} />
  );
};

export default EstadoSolicitudDropdown;

const estadosSolicitudAnalisis: IListItem[] = [
  {
    value: "Todos",
    label: "Todos",
  },
  {
    value: ESituacionOperacion.En_Analisis,
    label: "En análisis",
  },
  {
    value: ESituacionOperacion.Informes_Pendientes,
    label: "Informes Pendientes",
  },
  {
    value: ESituacionOperacion.Rechazada,
    label: "Rechazada",
  },
  {
    value: ESituacionOperacion.Aprobada,
    label: "Aprobada",
  },
  {
    value: ESituacionOperacion.Confeccion_Solicitada,
    label: "Confección Solicitada",
  },
  {
    value: ESituacionOperacion.En_Espera_Informes_Riesgo_Vehiculo,
    label: "En espera informes Riesgo Vehículo",
  },
];

const estadosSolicitudConfeccion: IListItem[] = [
  {
    value: "Todos",
    label: "Todos",
  },
  {
    value: ESituacionOperacion.Confeccion_Solicitada,
    label: "Confección Solicitada",
  },
  {
    value: ESituacionOperacion.Con_Vehiculo_Aprobado,
    label: "Con Vehículo Aprobado",
  },
  {
    value: ESituacionOperacion.Prenda_Confeccionada,
    label: "Prenda Confeccionada",
  },
];

const estadosSolicitudLiquidacion: IListItem[] = [
  {
    value: "Todos",
    label: "Todos",
  },
  {
    value: ESituacionOperacion.Prenda_Confeccionada,
    label: "Prenda Confeccionada",
  },
  {
    value: ESituacionOperacion.Liquidada,
    label: "Liquidada",
  },
];

const estadosSolicitudConsumo: IListItem[] = [
  {
    value: "Todos",
    label: "Todos",
  },
  {
    value: EEstadoSolicitudConsumo.Incompleta,
    label: "Incompleta",
  },
  {
    value: EEstadoSolicitudConsumo.En_Analisis,
    label: "En Análisis",
  },
  {
    value: EEstadoSolicitudConsumo.Aprobada,
    label: "Aprobada",
  },
  {
    value: EEstadoSolicitudConsumo.Liquidada,
    label: "Liquidada",
  },
  {
    value: EEstadoSolicitudConsumo.Rechazada,
    label: "Rechazada",
  },
  {
    value: EEstadoSolicitudConsumo.Desistida,
    label: "Desistida",
  },
];

export enum ERangoFecha {
  Aprobada = "Aprobada",
  Liquidada = "Liquidada",
}

const rangoFechaConsumo: IListItem[] = [
  {
    value: "Alta",
    label: "Fecha de Alta",
  },
  {
    value: ERangoFecha.Aprobada,
    label: "Fecha de Aprobación",
  },
  {
    value: ERangoFecha.Liquidada,
    label: "Fecha de Liquidación",
  },
];

export const estadosSolicitud = {
  Analisis: estadosSolicitudAnalisis,
  Confeccion: estadosSolicitudConfeccion,
  Liquidacion: estadosSolicitudLiquidacion,
  Consumo: estadosSolicitudConsumo,
  ConsumoYen: rangoFechaConsumo,
};
